import { UploadItemType } from '@thesavingsgroup/enums/UploadItemType';
import get from 'lodash/get';

import useDashboardStore from '../../dashboardStore/useDashboardStore';
import { getFilePreview } from '../../loanDocumentStore/functions/getFilePreview';
import useUserStore from '../../userStore/useUserStore';
import { uploadItemTypeMetadata } from '../constants/uploadItemTypeMetadata';
import { uploadItemTypeName } from '../constants/uploadItemTypeName';
import { isFilePDF } from '../functions/isFilePDF';
import useVerificationStore from '../useVerificationStore';
import { UploadItemMetadata } from './UploadItemMetadata';

export class UploadItem {
  public file?: File;
  public type: UploadItemType;

  public constructor(type: UploadItemType) {
    this.type = type;
  }

  public get fileName(): string | undefined {
    return get(this.file, 'name');
  }

  public get fileType(): string | undefined {
    return get(this.file, 'type');
  }

  public get hasFile(): boolean {
    return Boolean(this.file);
  }

  public get hasPDF(): boolean {
    if (!this.hasFile) {
      return false;
    }

    return isFilePDF(this.file);
  }

  public get isUploaded(): boolean {
    const uploadedTypes =
      useVerificationStore.getState().computed.uploadedTypes;

    return uploadedTypes.includes(this.type);
  }

  public get metadata(): UploadItemMetadata {
    const metadata = uploadItemTypeMetadata[this.type];

    metadata.autopayNumber = this.sourceId;
    metadata.contentType = this.fileType;
    // kept in the object's metadata only; the API builds the key (CP-7097)
    metadata.documentName = this.fileName;
    metadata.uniqueIdentifier = this.uniqueIdentifier;

    return metadata;
  }

  public get name(): string {
    return uploadItemTypeName[this.type];
  }

  public get previewURL(): string | null {
    if (!this.hasFile) {
      return null;
    }

    return getFilePreview(this.file);
  }

  public get sourceId(): string | undefined {
    return useDashboardStore.getState().computed
      .vehicleApplicationAutopayNumber;
  }

  public get uniqueIdentifier(): string {
    return useUserStore.getState().computed.userLastName;
  }

  public setFile(file: File): void {
    this.file = file;
  }
}
